"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.stateToProps = void 0;
var businessSelectors = __importStar(require("@src/reduxStores/business/selectors"));
exports.stateToProps = function (state) {
    return {
        businessId: businessSelectors.getBusinessId(state),
        businessViaName: businessSelectors.getViaName(state),
        pipelineVersion: businessSelectors.getPipelineVersion(state),
        activePartners: businessSelectors.getActivePartners(state),
    };
};
var BotActions_1 = require("@src/actions/BotActions");
__createBinding(exports, BotActions_1, "createAlert");
